import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useChildProfile } from "../contexts/ChildProfileContext";
import { PictureButton } from "../design/PictureButton";
import { TokenCounter } from "../design/TokenCounter";
import { MascotBubble } from "../design/MascotBubble";
import { avatarLabel } from "../lib/assets";
import { BigButton } from "../design/BigButton";
import { Sparkles, BookOpen, Gift, Compass, Shield } from "lucide-react";

export function ChildHomeScreen() {
  const { profileId } = useParams();
  const { profiles, selected, select } = useChildProfile();
  const navigate = useNavigate();

  useEffect(() => {
    if (selected?.id !== profileId) {
      const match = profiles.find((p) => p.id === profileId);
      if (match) select(profileId);
    }
  }, [profileId, profiles, selected, select]);

  if (!selected) {
    return <div className="wmleye-app" data-testid="child-home-loading">Getting things ready…</div>;
  }

  const nickname = selected.nickname;

  return (
    <div className="wmleye-app child-home" data-testid="child-home">
      <header className="child-home__header">
        <div className="child-home__me">
          <div className="child-home__avatar" aria-hidden>
            {avatarLabel(selected.avatar)}
          </div>
          <div>
            <div className="child-home__hello" data-testid="child-home-nickname">Hi {nickname}!</div>
            <div className="child-home__sub">Ready to explore?</div>
          </div>
        </div>
        <TokenCounter value={selected.tokenBalance || 0} />
      </header>
      <div className="child-home__mascot">
        <MascotBubble text={`Hi ${nickname}! Ready to explore?`} />
      </div>

      <div className="child-home__grid" role="menu">
        <PictureButton
          icon={<Compass size={44} aria-hidden />}
          label="Play"
          background="linear-gradient(135deg, #4ec5f1, #6ea9ff)"
          onClick={() => navigate(`/child/${profileId}/worlds`)}
          testId="child-home-play"
        />
        <PictureButton
          icon={<Sparkles size={44} aria-hidden />}
          label="Daily Find"
          background="linear-gradient(135deg, #ffd447, #ff9e48)"
          onClick={() => navigate(`/child/${profileId}/daily`)}
          testId="child-home-daily"
        />
        <PictureButton
          icon={<Gift size={44} aria-hidden />}
          label="My Rewards"
          background="linear-gradient(135deg, #ff7a6b, #d95d39)"
          onClick={() => navigate(`/child/${profileId}/rewards`)}
          testId="child-home-rewards"
        />
        <PictureButton
          icon={<BookOpen size={44} aria-hidden />}
          label="Word Book"
          background="linear-gradient(135deg, #6ecb63, #4c956c)"
          onClick={() => navigate(`/child/${profileId}/wordbook`)}
          testId="child-home-wordbook"
        />
        <PictureButton
          icon={<Shield size={44} aria-hidden />}
          label="Parent Area"
          background="linear-gradient(135deg, #9b6bff, #6a4cff)"
          onClick={() => navigate("/parent/gate")}
          testId="child-home-parent"
        />
      </div>
      <BigButton
        variant="ghost"
        onClick={() => navigate("/profiles")}
        className="child-home__switch"
        data-testid="child-home-switch"
      >
        Switch player
      </BigButton>
    </div>
  );
}
